export default "__VITE_ASSET__CX8CBTf0__"